export const USER_DISTINCT_ID_PARAMETER = 'mpUserDistinctId';
export const SEGMENT_ANONYMOUS_ID_COOKIE_NAME = 'ajs_anonymous_id';
export const SEGMENT_ANONYMOUS_ID_HEADER = 'x-madpaws-segment-anonymous-id';
